export default "__VITE_ASSET__4a1dfb80__"